import React, { useState } from 'react';
import PropTypes from 'prop-types';

// HOOKS
import useShowExitIntent from '@/hooks/useShowExitIntent';

// HELP
import DialogFindInternetOffers from './DialogFindInternetOffers';
import DialogFindMyBundle from './DialogFindMyBundle';

const DialogType = {
  FindMyBundle: 'fmb',
  FindInternetOffers: 'internet-offer',
};

const DialogMap = {
  [DialogType.FindMyBundle]: DialogFindMyBundle,
  [DialogType.FindInternetOffers]: DialogFindInternetOffers,
};

function DialogShowIntent({ children, ...props }) {
  useShowExitIntent(props);

  return children;
}

function DialogShowExitIntent({ id, type, onOpen }) {
  const [open, setOpen] = useState(false);

  const Dialog = DialogMap[type];

  if (!Dialog) {
    return null;
  }

  function handleOpen() {
    setOpen(true);
    onOpen();
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <DialogShowIntent id={id} onShow={handleOpen}>
      <Dialog open={open} onClose={handleClose} />
    </DialogShowIntent>
  );
}

DialogShowExitIntent.defaultProps = {
  onOpen: () => {},
};

DialogShowExitIntent.propTypes = {
  id: PropTypes.number.isRequired,
  onOpen: PropTypes.func,
  type: PropTypes.string,
};

export default DialogShowExitIntent;
